import { NavLink } from 'react-router-dom';
import React from 'react';
import { cn } from '../../lib/utils';
import { icons } from '../ui/Icons';

export interface PageHeaderProps {
  title: string;
  description?: string;
  breadcrumbs?: Array<{ label: string; href?: string }>;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, description, breadcrumbs, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between', className)}>
      <div className="min-w-0">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className="mb-3 flex items-center gap-1.5 text-sm text-neutral-500 dark:text-neutral-400" aria-label="Breadcrumb">
            {breadcrumbs.map((item, index) => (
              <React.Fragment key={`${item.label}-${index}`}>
                {index > 0 && <icons.ChevronRight className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />}
                {item.href ? (
                  <NavLink to={item.href} className="hover:text-neutral-800 dark:hover:text-neutral-200">
                    {item.label}
                  </NavLink>
                ) : (
                  <span className="font-medium text-neutral-900 dark:text-neutral-100">{item.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1 className="text-h1 font-semibold text-neutral-900 dark:text-neutral-100">{title}</h1>
        {description && <p className="mt-1 max-w-3xl text-body text-neutral-600 dark:text-neutral-300">{description}</p>}
      </div>
      {actions && <div className="flex flex-shrink-0 flex-col gap-2 sm:flex-row sm:items-center">{actions}</div>}
    </div>
  );
}
